<template>
    <div class="needPayContainer">
        <van-nav-bar
                title="待支付订单"
                left-arrow
                :fixed='true'
                @click-left="onClickBack"
            />
        <div class="needPayInfo"  v-if="orderInfo">
            <van-panel :title="orderInfo.createTime" status="待支付">
                <van-cell-group>
                    <van-field  v-model="orderInfo.orderCode" label="定单号" readonly />
                    <van-field  v-model="orderInfo.serialNumber" label="手机号" readonly />
                    <van-field  v-model="orderInfo.baseFee" label="预存费" readonly />
                    <van-field  v-model="orderInfo.payLogistics" label="快递费" readonly />
                    <van-field v-model="orderInfo.fee" label="需付款" readonly />
                </van-cell-group>
            </van-panel>
            <div class='needPayInfo-btn'>
                <van-button type="primary" size="large" @click="toPay" :loading='submitLoading' loading-text='正在提交...'>确认支付</van-button>
            </div>
            <div class="needPayInfo-warning">
                    温馨提示：
                    <div>1、请尽快完成支付，以免错失您中意的号码。</div>
                    <div>2、支付完成后可在首页订单中根据根据要求进行查询。</div>
                </div>
        </div>
    </div>
    
</template>

<script>
  import {setAesString,getAesString} from "../../config/date";
  import {isWeiXin} from '../../common/functionUtil';

export default {
    name: 'needPayInfo',
    data(){
        return{
            platform:'weixin',
            submitLoading:false,
            orderInfo:{}
        }
    },
    created(){
        this.orderInfo = sessionStorage.getItem(setAesString("orderInfo"));
        this.miaoShaDefine = sessionStorage.getItem(setAesString("miaoShaDefine"));
        if(this.orderInfo == null){
            this.$dialog.alert({
                message: '支付信息获取失败,返回上一步重新操作!'
            }).then(() => {
                //提交数据
                this.$router.push({
                    path:'/index'
                });
            });
            return;
        }
        this.orderInfo = JSON.parse(getAesString(this.orderInfo));
        this.orderInfo.fee = this.orderInfo.fee/100+'元';
        this.orderInfo.baseFee = this.orderInfo.baseFee/100+'元';
        this.orderInfo.payLogistics = this.orderInfo.payLogistics/100+'元';

    },
    mounted() {
        if(this.isWeiXin()){
            this.platform = "weixin";
        }else{
            this.platform = "other";             
        }
    },
    methods: {
        isWeiXin,
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        toPay(){
            if(this.orderInfo == null){
                this.$dialog.alert({
                    message: '订单信息不存在,返回上一步重新操作!'
                }).then(() => {
                    this.$router.back(-1);//返回上一层
                });
                return;
            }
            var formdata = {
                service:'user.choiceNumberPay',
                orderCode:this.orderInfo.orderCode,
                serialNumber:this.orderInfo.serialNumber,
                platform:this.platform,
                successUrl:this.$api.locationUrl+'/choiceNumber/index',
            }
            var continuePay = sessionStorage.getItem(setAesString("continuePay"));
            if(continuePay != null){
                formdata.continuePay = true;
            }
            //非微信平台,设置中间页面
            if(this.platform == "other"){
                var redirectUrl = this.$api.locationUrl+"/choiceNumber/checkPayResult?od="+setAesString(this.orderInfo.orderCode)+"&num="+setAesString(this.orderInfo.serialNumber);
                formdata.redirectUrl = redirectUrl;
            }

            this.submitLoading = true;
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.submitLoading = false;
                window.location.href=res;
            },(res)=>{
                this.submitLoading = false;
                this.$toast.fail(res.errorMsg);
            });
        }
    }
}
</script>

<style lang="less">
@main-blue: #20A0FF;
@main-white: #ffffff;

.needPayInfo{
    height: 100%;
    padding: 10px;
    border-radius: 50px;
    margin-top: 47px;
    &-data{
        margin-top: 50px;
        background-color:@main-white;
        padding: 20px;
        margin-bottom: 10px;
    }

    &-btn{
        text-align: center;
        margin: 50px 10px;
    }
    &-warning{
        font-size: 12px;
        color:red;
        margin: 0px 10px;
    }
}




</style>
